import { createMuiTheme } from '@material-ui/core';

declare module '@material-ui/core/styles/createPalette' {
  interface Palette {
    offline: Palette['primary'];
  }
  interface PaletteOptions {
    offline: PaletteOptions['primary'];
  }
}

export interface ThemeInterface {
  primary: {
    main: string
    light: string
    dark: string
    contrastText: string
  };
  secondary: {
    main: string
    light: string
    dark: string
    contrastText: string
  };
  approved: string;
  rejected: string;
  textShadow: string;
}

export default interface FullInterface extends ThemeInterface {
  white: {
    main: string
    light: string
    dark: string
    contrastText: string
  };
  black: {
    main: string
    light: string
    dark: string
    contrastText: string
  };
  summary: {
    green: string
    orange: string
    blue: string
    red: string
    grey: string
  },
    chart: {
      main: {
        green: string,
        orange: string,
        gray: string
      },
      hover: {
        green: string,
        orange: string,
        gray: string
      }
    },
    reports: string,
    tableHeader: string,
  grey: {
    light: string,
    dark: string,
  },
  rgb: {
    dark: string,
    yellow: string,
  }
  header: string,
  animationsEnabled: boolean;
  panel: string;
  error: string;
  warning: string;
  activeToday: string;
  highlighted: {
    orange: string
    grey: string
    aiLabel: string
    aiContainer: string;
  }
}

export const theme: FullInterface = {
  primary: {
    main: '#04aff8',
    light: '#354a5f',
    dark: '#c66900',
    contrastText: '#424242',
  },
  secondary: {
    main: '#444',
    light: '#757575',
    dark: '#1b1b1b',
    contrastText: '#fff',
  },
  white: {
    main: '#edeff0',
    light: '#fff',
    dark: '#e6e6e6',
    contrastText: '#111',
  },
  black: {
    main: '#333',
    light: '#7e7e7e',
    dark: '#000',
    contrastText: '#fff',
  },
  animationsEnabled: true,
  summary: {
    green: '#188918',
    orange: '#e9730c',
    blue: '#0a6ed1',
    red: '#ff5c5c',
    grey: '#89919a',
  },
  chart: {
    main: {
      green: '#188918',
      orange: '#e9730c',
      gray: '#89919a'
    },
    hover: {
      green: '#7cd37c',
      orange: '#ffc97a',
      gray: '#dddddd'
    }
  },
  header: '#fff',
  approved: '#2db346',
  panel: '#354a5f',
  rejected: '#cd5e68',
  textShadow: 'none',
  activeToday: '#ff0000',
  error: '#ef4e4e',
  warning: '#FFA500',
  highlighted: {
    orange: '#c8c187',
    grey: '#dddddd',
    aiLabel: '#039008',
    aiContainer: '#d0f7db',
  },
  reports: '#bbb',
  tableHeader: '#868080',
  grey: {
    light: 'rgba(0, 0, 0, 0.1)',
    dark: 'rgba(66, 66, 66, 0.08)',
  },
  rgb: {
    dark: '#ff5622',
    yellow: '#fff2db',
  },
};

export const muitheme = createMuiTheme({
  overrides: {
      MuiCollapse: {
          entered: {
              height: 'auto',
              overflow: 'visible'
          },
      },
  },
  palette: {
      primary: {
          light: '#04aff8',
          main: '#04aff8',
          dark: '#04aff8',
          contrastText: '#000000',
      },
      secondary: {
        main: '#354a5f',
        light: '#62758c',
        dark: '#0b2336',
        contrastText: '#ffffff'
      },
      common: {
        white: '#f3f3f3',
        black: '#111',
      },
      offline: {
        main: '#e66b6b'
      },
      error: {
        main: '#ef4e4e'
      }
  },
  typography: {
      h6: {
          fontWeight: 300,
      },
      useNextVariants: true,
  },
});